"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Card_1 = require("@/components/dataCard/Card");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
var AmountSize;
(function (AmountSize) {
    AmountSize[AmountSize["Big"] = 0] = "Big";
    AmountSize[AmountSize["Medium"] = 1] = "Medium";
    AmountSize[AmountSize["Small"] = 2] = "Small";
})(AmountSize || (AmountSize = {}));
const FOC = ({ data, isPageLoading }) => {
    if (!isPageLoading && data) {
        return (react_1.default.createElement(Card_1.Card, { bg: "bg", radius: 20, amountSize: AmountSize.Big, isborder: true, data: data, key: data.title, cardwidth: {
                xs: 12,
                sm: 12,
                md: 12,
                lg: 6,
                xl: 6,
            } },
            react_1.default.createElement(GridContainer, null, data?.children?.map((e, i) => {
                return (react_1.default.createElement(Card_1.Card, { horizontal: true, radius: 200, amountSize: AmountSize.Small, key: `${e}-${i}`, isborder: false, bg: 'contrastBg', data: e, cardwidth: {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    } }, e.children?.map((e, i) => {
                    return (react_1.default.createElement(Card_1.Card, { radius: 10, margin: '20px 0 0 0', amountSize: AmountSize.Small, key: `${e}-${i}`, data: e, isborder: false, cardwidth: {
                            xs: 12,
                            sm: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }, bg: "contrastBg" }));
                })));
            }))));
    }
    else if (!data || isPageLoading) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
};
exports.default = FOC;
const GridContainer = (0, styled_components_1.default)('div') `
  display: grid;
  grid-column: span 12;
  width: 100%;
  grid-template-columns: repeat(12, 1fr);
  gap: 15px;
  height: fit-content;
  align-self: flex-end;
  ${(props) => props.theme.media.lg} {
  }
  ${(props) => props.theme.media.md} {
    row-gap: 10px;
  }
  ${(props) => props.theme.media.sm} {
  }
  ${(props) => props.theme.media.xs} {
  }
`;
